import { ResourceProvider } from "hooks/resources/providers/resourceProvider";
import { DataTableContainer } from "./data-table-container";
import { DataTableConfig } from "./types/data-table.config";
import { Resource } from "hooks/resources/@types/resource.type";

type DataTableProps = {
  table: React.ReactNode;
  form: React.ReactNode;
  resource: Resource;
  params?: Record<string, string>;
  config?: Partial<DataTableConfig>;
};

export function DataTable<T>({ table, form: modal, resource, params, config }: DataTableProps) {
  const configuration = {
    hideHeader: false,
    hideSearch: false,
    hideMenu: false,
    ...config,
  };

  return (
    <ResourceProvider<T> resource={resource} params={params}>
      <DataTableContainer table={table} modal={modal} configuration={configuration} />
    </ResourceProvider>
  );
}
